import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
    getSortedExceptions,
    getRuleEditProperties,
} from "store/features/emailScheduler/definition/definition.selectors";
import { getRuleDetailsById } from "store/features/emailScheduler/overview/overview.selectors";
import { createDefaultRuleDefaultFormValues } from "validation/components/EmailScheduler/emailSchedulerFormRules";

export const useSchedulerFormReset = () => {
    const exceptions = useSelector(getSortedExceptions);
    const { isEdited, ruleId, isCopy } = useSelector(getRuleEditProperties);
    const ruleDetails = useSelector(getRuleDetailsById(ruleId));
    const { t } = useTranslation();

    if (isEdited && ruleDetails) {
        if (isCopy) {
            return {
                ...ruleDetails,
                general: {
                    ...ruleDetails.general,
                    name: t("templates.createSchedulerRule.label.copyOf", { rule: ruleDetails.general.name }),
                    exceptions: exceptions.map((exception) => {
                        return {
                            name: exception,
                            isChecked: ruleDetails.general.exceptions.some(({ name }) => name === exception),
                        };
                    }),
                },
            };
        }

        return {
            ...ruleDetails,
            general: {
                ...ruleDetails.general,
                exceptions: exceptions.map((exception) => {
                    return {
                        name: exception,
                        isChecked: ruleDetails.general.exceptions.some(({ name }) => name === exception),
                    };
                }),
            },
        };
    }

    return createDefaultRuleDefaultFormValues;
};
